export default __webpack_public_path__ + "static/media/ss_railing1.3b2c3592.jpeg";